module.exports = __webpack_public_path__ + "files/3f4e68bf43e3bccdda93832a0f595677.png";